<template>
  <div class="mobileHall padding80">
    <Header :current="0"></Header>
    <Card ref="Card" cardIndex="3"></Card>
    <div
      class="carouselContent"
      v-for="(item, index) in LeiMonList"
      :key="index"
    >
      <div class="carouselMain" v-if="item.iconPosition == 'left'">
        <div class="carouselMainLeft">
          <div class="LeftMain">
            <div class="mobileHallTitle LeftTitle">
              {{ item.title }}
            </div>
            <div class="mobileHallTips LeftTips">
              {{ item.tips }}
            </div>
            <div class="LMCCMore" @click="moreModel(item.url)">
              <div class="moreContent">
                <span>{{ item.more ? item.more : "了解更多" }}</span>
                <img src="../../assets/icon/icon_arrow.png" alt="" />
              </div>
            </div>
          </div>
        </div>
        <div class="carouselMainRight" :id="item.id">
          <Banner
            :images="item.list"
            image-width="100%"
            :image-height="imageHeight"
          ></Banner>
        </div>
      </div>
      <div class="carouselMain" v-if="item.iconPosition == 'right'">
        <div class="carouselMainRight" :id="item.id">
          <Banner
            :images="item.list"
            image-width="100%"
            :image-height="imageHeight"
          ></Banner>
        </div>
        <div class="carouselMainLeft">
          <div class="rightMain">
            <div class="mobileHallTitle">
              {{ item.title }}
            </div>
            <div class="mobileHallTips LeftTips">
              {{ item.tips }}
            </div>
            <div class="LMCCMore" @click="moreModel(item.url)">
              <div class="moreContent">
                <span>{{ item.more ? item.more : "了解更多" }}</span>
                <img src="../../assets/icon/icon_arrow.png" alt="" />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <Footer></Footer>
  </div>
</template>

<script>
import cardMixins from "@/mixins/cardMixins";

export default {
  name: "mobileHall",
  mixins: [cardMixins],
  data() {
    return {
      imageHeight: 1010 * 0.75,
      LeiMonList: [
        {
          iconPosition: "left",
          title: "移动工作站",
          tips:
            "移动工作站是员工服务渠道产品，让客户经理可以离开物理网点，像送外卖一样，将金融服务送 到客户手中。",
          more: "",
          url: "mobileWorkstation",
          id: "images0",
          changeType: false,
          list: [
            {
              src: require("../../assets/mobile/mobile.png")
            },
            {
              src: require("../../assets/mobile/mobile1.png")
            },
            {
              src: require("../../assets/mobile/mobile2.png")
            }
          ]
        },
        {
          iconPosition: "right",
          title: "移动营业厅",
          tips:
            "移动营业厅是客户服务渠道，是下一代的手机银行，是客户与银行接触的主要渠道，能为客户提供像在物理网点一样的、有互动的、温馨的金融和商业服务。",
          more: "",
          url: "mobileBusiness",
          id: "images1",
          changeType: true,
          list: [
            {
              src: require("../../assets/mobile/mobile3.png")
            },
            {
              src: require("../../assets/mobile/mobile4.png")
            }
          ]
        }
      ]
    };
  },
  mounted() {},
  methods: {
    moreModel(value) {
      this.$router.push({
        path: "/mobileHallDetail",
        query: { type: value }
      });
    }
  }
};
</script>

<style scoped lang="less">
.mobileHall {
  .carouselMain {
    display: flex;
    margin-bottom: 30 * 0.75px;
    width: 100%;
    height: 1010 * 0.75px;
    background-repeat: no-repeat;
    background-size: cover;
    background-image: url("../../assets/bg/bg1.png");
    .carouselMainLeft {
      width: 50%;
      height: 1010 * 0.75px;
      .mobileHallTitle {
        font-size: 50 * 0.75px;
        font-family: PingFangSC-Semibold, PingFang SC;
        font-weight: 600;
        color: #000000;
        line-height: 140 * 0.75px;
        margin-top: 325 * 0.75px;
      }
      .mobileHallTips {
        margin-top: 46 * 0.75px;
        font-size: 26 * 0.75px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #333333;
        line-height: 48 * 0.75px;
      }
    }
    .carouselMainRight {
      width: 50%;
      height: 1010 * 0.75px;
    }
  }
}
.LMCCMore {
  margin-top: 46 * 0.75px;
  width: 169 * 0.75px;
  height: 49 * 0.75px;
  border-radius: 8 * 0.75px;
  border: 3 * 0.75px solid #666666;
  font-size: 20 * 0.75px;
  font-family: PingFangSC-Medium, PingFang SC;
  font-weight: 500;
  color: #333333;
  line-height: 49 * 0.75px;
  text-align: center;
  cursor: pointer;
  display: flex;
  .moreContent{
    margin: 0 auto;
    display: flex;
    text-align: center;
    img {
      padding-left: 10px;
      padding-top: 11px;
      width: 24 * 0.75px;
      height: 19 * 0.75px;
    }
  }
}
.LeftTips {
  width: 546px * 0.75px;
}
.LeftMain {
  padding-left: 360 * 0.75px;
}
.rightMain {
  padding-left: 53 * 0.75px;
}
</style>
